<template>
    <div>
        <span ref="top"></span>

        <div class="col-12 p10-0 borderTop borderBottom mt20 relative">

            <div class="floatRightI col-12-s">
                <ul class="viewButtons">
                    <li :class="(activeLayout === 'row' ? 'active' : '')" @click="switchView(true)">
                        <span><i class="fa fa-reorder"></i></span>
                    </li>
                    <li :class="(activeLayout === 'tile' ? 'active' : '')" @click="switchView(false)">
                        <span><i class="fa fa-th"></i></span>
                    </li>
                </ul>
                <div class="selectBoxCol">
                    <select id="sorteer" class="selectBox" v-model="currentSort">
                        <option
                            v-for="(label, field) in sortOptions"
                            :value="field"
                            :key="field"
                            :label="label"
                            v-text="label"
                        ></option>
                    </select>
                </div>
            </div>
        </div>

        <div class="col-12 mt10" v-if="isLoading">
            <spinner :waiting="isLoading" class="product-list-spinner"></spinner>
        </div>
        <div class="col-12 mt10" v-else-if="hasProducts">
            <div :class="wrapperClass" class="nonEqualHeight">
                <product
                    v-for="(product, index) in list"
                    :key="product.id"
                    :product="product"
                    :lang="lang"
                    :layout-class="activeLayout"
                ></product>
            </div>
            <!-- Paginator-->
            <div class="col-12 p10-0 borderTop borderBottom">
                <ul class="pagination">
                    <li v-if="currentPage > 1">
                        <a @click="pageTo(currentPage -  1)">
                            <i class="fa fa-arrow-left"></i>
                            <span class="sr-only">previous</span>
                        </a>
                    </li>
                    <li v-for="n in currentMaxPage" :class="{ selected: (n === currentPage) }">
                        <a v-text="n" @click="pageTo(n)" v-if="(n !== currentPage)"></a>
                        <span class="boldFont" v-else v-text="n"></span>
                    </li>
                    <li v-if="currentPage < currentMaxPage">
                        <a @click="pageTo(currentPage + 1)">
                            <i class="fa fa-arrow-right"></i>
                            <span class="sr-only">next</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-12 paragraph p10-0 borderBottom small" v-else>
            <span v-text="this.lang.no_products"></span>
        </div>
    </div>
</template>

<script>
// import CustomSelect from "./CustomSelect";
// import CustomOption from "./CustomOption";
import Product from './Product';
import Spinner from './Spinner';
import {EventBus} from "../../events";
import {debounce} from 'lodash';

// Allow cancellation
const CancelToken = require('axios').CancelToken;
let cancelSource;

export default {
    name: "ProductList",
    components: {
        Product,
        Spinner,
        // CustomSelect,
        // CustomOption,
    },
    props: {
        category: {
            required: false,
            type: String,
            default: null,
        },
        productType: {
            required: false,
            type: String,
            default: "",
        },
        productFeature: {
            required: false,
            type: String,
            default: "",
        },
        sortBy: {
            required: false,
            type: String,
            default: 'code'
        },
        sortDirection: {
            required: false,
            type: String,
            default: 'ASC'
        },
        sortOptions: {
            required: false,
            type: Object,
            default: () => {
                return {
                    'price|ASC': 'Prijs aflopend',
                    'price|DESC': 'Prijs oplopend',
                }
            }
        },
        perPage: {
            required: false,
            default: 50,
        },
        page: {
            required: false,
            type: Number,
            default: 1,
        },
        lang: {
            required: true,
            type: Object,
        }
    },
    data() {
        return {
            isLoading: true,
            products: [],
            currentSort: null,
            currentPage: null,
            nextPage: null,
            currentMaxPage: null,
            afterFirstLoad: false,
            activeLayout: "row",
            pagesToShow: []
        }
    },
    methods: {
        pageTo(nextPage) {
            this.nextPage = nextPage;
            if (nextPage !== this.currentPage) {
                this.getProducts();
            }
        },
        getProducts: debounce(function () {
            cancelSource && cancelSource.cancel('Request cancelled');
            cancelSource = CancelToken.source();

            this.isLoading = true;
            if (this.afterFirstLoad) {
                //this.$refs.top.scrollIntoView();
            }

            let slugs = [];
            if(this.productType){
                slugs.push(this.productType);
            }
            if (this.category) {
                slugs.push(this.category);
            }
            if(this.productFeature){
                slugs.push(this.productFeature);
            }

            let urlString = '';
            slugs.forEach(function(slug){
                urlString += '/' + slug;
            })
            urlString += '/';

            let params = {
                direction: this.currentSortDirection,
                sort_by: this.currentSortBy,
                per_page: this.perPage
            };

            // Push params to url
            this.filter.toUrlString(this.nextPage, params, false, true);
            axios.post(`/api/site/products${urlString}${this.filter.toRawUrlString(this.nextPage, params)}`, {
            }, {
                cancelToken: cancelSource.token
            })
            .then(response => {
                let products = response.data.products;

                this.afterFirstLoad = true;
                this.products = products;

                if (response.data.meta) {
                    this.currentPage = response.data.meta.current_page;
                    this.currentMaxPage = response.data.meta.last_page;
                } else {
                    this.currentPage = 1;
                    this.currentMaxPage = 0;
                }
                this.pagesToShow = [this.currentPage, this.currentMaxPage];

                if (response.data.hasOwnProperty('counts')) {
                    EventBus.$emit('update_counts', response.data.counts)
                }

                window.trackImpressionsGoogle(products);
            })
            .catch(error => {
                if (axios.isCancel(error)) {
                    // We cancelled this request...
                } else {
                    // handle error
                }
            }).finally(() => {
                this.isLoading = false;
            });
        }, 300),
        getProductImageWidth() {
            // let screenWidth = window.innerWidth;
            // let listWidth = this.$el.offsetWidth;
            let productWidth = 200;

            productWidth = Math.ceil(productWidth / 10) * 10;

            // if (this.ScreenIsRetina) {
            //     productWidth = productWidth * 2;
            // }

            return productWidth;
        },
        switchView(reset){
            this.activeLayout = (reset ? 'row' : 'tile');
        }
    },
    watch: {
        currentSort() {
            this.getProducts();
        }
    },
    computed: {
        list() {
            return this.products;
        },
        filter() {
            return this.$store.getters['filter/get'];
        },
        hasProducts() {
            return this.products ? this.products.length > 0 : false;
        },
        currentSortBy() {
            return this.currentSort.split('|')[0];
        },
        currentSortDirection() {
            return this.currentSort.split('|')[1];
        },
        currentSortLabel() {
            return this.sortOptions[this.currentSort];
        },
        wrapperClass() {
            return this.activeLayout === 'row' ? 'col-12' : 'col-12 grid-3';
        }
    },
    created() {
        this.currentSort = this.sortBy + '|' + this.sortDirection;
        this.nextPage = this.page;

        EventBus.$on('filter_updated', payload => {
            this.getProducts();
        });

        this.getProducts();
    },
    mounted() {
        this.isLoading = true;
    }
}
</script>

<style scoped lang="scss">
.product-list-spinner {
    /*position: absolute;*/
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.gritter {
    width: calc(100% + 20px);
    margin-left: -10px;
}

/*.grid-item.doubleHeight {*/
/*    margin-bottom: 108px;*/
/*}*/


.filter-top-bar {
    justify-content: space-between;
    align-items: center;
    flex-direction: row-reverse;
}

@media screen and (max-width: 730px) {
    .filter-top-bar {
        flex-direction: column;

        .button-section {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-bottom: 10px;

            .selectWidth {
                width: 100%;
            }
        }
    }
}
</style>
